<template lang="pug">
    MatchMedia(v-slot='{ screenSM }')
        .profile-blocked(v-if="blocked")
            .profile-blocked__img-overlay
            .profile-blocked__info
                svg-icon(iconId="user")
                .profile-blocked__title This account is currently not available.
        .profile-page(v-else-if="loaded")
            .profile-page-head(:style="backgroundHead")
            .profile-content(:class="theClass")
                .profile-content-left
                    .profile-content__head-wrap
                        .profile-content__head-image
                            .profile-content__head-image-wrap(:style="backgroundProfile")
                                .profile-content__head-image-placeholder(v-if="!user.profile_image")
                                    svg-icon(iconId="profile-image-placeholder")

                        .profile-content__head-body
                            span.profile-head-name-owner {{ user.name }}
                            .profile-head-subanme-info
                                span(v-if="user.username") @{{ user.username }}
                                span(v-if="user.online_status") {{ user.online_status }}
                            .profile-head__following-status
                                span.profile-followers(v-if="showFollowersCount" @click="openFollowers")
                                    svg-icon(iconId="people")
                                    span {{ user.followers_count }} followers
                                span.profile-following(@click="openFollowings")
                                    svg-icon(iconId="following")
                                    span {{ user.following_count }} following
                            .profile-head__following-actions(v-if="subscribable || followable")
                                button.b-profile-following(v-if="followable" @click="toggleFollow" :class="{ 'b-profile-following--followed': isFollowed }") {{ followButtonLabel }}
                                button.b-profile-following(v-if="subscribable" @click="openSubscribe") Subscribe

                    .profile-content-left__padding
                        .profile-content__body
                            p.profile-content__body-description(v-html="user.meta.about_show")
                            .profile-content__body-location(v-if="user.meta.website_url || location")
                                .bank-link(:style="{visibility: user.meta.website_url ? 'visible' : 'hidden'}")
                                    svg-icon(iconId="chain")
                                    span {{ user.meta.website_url }}
                                .user-location(:style="{visibility: location ? 'visible' : 'hidden'}")
                                    svg-icon(iconId="location-marker")
                                    span {{ location }}
                            .profile-content__body-links(v-if="links.length")
                                a(v-for="link in links" :href="link.link" target="_blank")
                                    svg-icon(:iconId="link.icon")

                        store-slider-control(v-if="user.creator" :user="user")
                        profile-files-container-control(v-show="showPhotoMediaSlider" title="Photos" @defaultAction="switchNavTab('photos')")
                            media-feed-control.profile-content__media-slider(:focusUserId="user.id" mediaType="image" :maxItems="3" mode="slider" :squareAspect="true" @load="showPhotoMediaSlider = $event.count")
                        profile-files-container-control(v-show="showVideoMediaSlider" title="Videos" @defaultAction="switchNavTab('videos')")
                            media-feed-control.profile-content__media-slider(:focusUserId="user.id" mediaType="video" :maxItems="3" mode="slider" :squareAspect="true" @load="showVideoMediaSlider = $event.count")
                .profile-content-right
                    tabs-control.profile-content__navigation-tabs(v-model="navigationTab" :tabs="navigationTabs" ref="navigationTabs")
                        template(v-slot:content-posts)
                            post-feed-control(:focusUserId="user.id")
                        template(v-slot:content-photos)
                            media-feed-control.profile-content__media-feed-tab(:focusUserId="user.id" mediaType="image" :mode="screenSM ? 'masonry' : 'column'")
                        template(v-slot:content-videos)
                            media-feed-control.profile-content__media-feed-tab(:focusUserId="user.id" mediaType="video" :mode="screenSM ? 'masonry' : 'column'")
</template>

<script>
import { mapGetters } from 'vuex'
import { MatchMedia } from 'vue-component-media-queries'
import ModalsList from '../components/modals/modals-list'
import EventBus from '../lib/event-bus'
import Events from '../lib/events'
import UserFollowsService from '../services/user-follows-service'
import UserProductsService from '../services/user-products-service'

export default {
    name: 'profile-page',

    components: {
        MatchMedia,
    },

    props: {
        username: {
            type: String,
        },
    },

    data() {
        return {
            loaded: false,
            user: null,
            navigationTab: null,
            subscriptions: [],
            showPhotoMediaSlider: false,
            showVideoMediaSlider: false,
            blocked: false,
        }
    },

    computed: {
        ...mapGetters(['authUser']),

        isFollowed() {
            return this.user.is_followed
        },
        followButtonLabel() {
            return this.isFollowed ? 'Unfollow' : 'Follow'
        },
        backgroundHead() {
            return this.user.cover_image ?
                { 'background-image': 'url(' + this.user.cover_image + ')' } :
                { 'background-color': 'rgba(146, 152, 151, 0.3)' }
        },
        backgroundProfile() {
            return this.user.profile_image ?
                { 'background-image': 'url(' + this.user.profile_image + ')' } :
                { }
        },
        navigationTabs() {
            return [
                { label: 'Posts', name: 'posts', iconId: 'document' },
                { label: 'Photos', name: 'photos', iconId: 'picture' },
                { label: 'Videos', name: 'videos', iconId: 'video-player' },
            ]
        },
        subscribable() {
            return !this.user.owner && this.user.creator && this.subscriptions.length
        },
        followable() {
            return !this.user.owner
        },
        showFollowersCount() {
            return this.user.owner || this.user.meta.followers_count_display
        },
        showFollowers() {
            return this.user.owner || this.user.meta.followers_display
        },

        links() {
            return ['instagram', 'tiktok', 'snapchat', 'twitter'].filter(k => this.user.meta[k]).map(k => {
                const link = this.user.meta[k]
                return {
                    icon: `${k}-icon`,
                    link: link.match(/^https?:\/\//i) ? link : `http://${link}`,
                }
            })
        },

        theClass() {
            return {
                'profile-content--owner': this.user.owner,
                'profile-content--show-followers-count': this.showFollowersCount,
                'profile-content--show-followers': this.showFollowers,
            }
        },
        location() {
            return [this.user.meta.location, this.user.meta.country_name].filter(Boolean).join(', ')
        },
    },

    watch: {
        username() {
            this.load()
        },
    },

    methods: {
        reset() {
            this.loaded = false
            this.showPhotoMediaSlider = false
            this.showVideoMediaSlider = false
        },

        async load() {
            this.reset()

            if (this.username) {
                try {
                    const {data: {data: user}} = await axios.get(`/api/customer/user/username/${this.username}`)
                    this.user = user
                } catch {
                    this.blocked = true
                    return;
                }
            } else {
                this.user = this.authUser
            }

            if (!this.user.owner && this.user.creator) {
                this.subscriptions = await UserProductsService.byType(this.user.id, 'subscription')
            }

            this.loaded = true
        },

        async toggleFollow() {
            if (this.isFollowed) {
                await UserFollowsService.unfollow(this.user.id)
            } else {
                await UserFollowsService.follow(this.user.id)
            }
            this.user.is_followed = !this.isFollowed
            if (this.showFollowersCount) {
                this.user.followers_count += (this.isFollowed * 2 - 1)
            }
        },

        switchNavTab(tab) {
            this.navigationTab = tab
            setTimeout(() => {
                this.$refs.navigationTabs.$el.scrollIntoView({ behavior: 'smooth' })
            }, 500)
        },

        openSubscribe() {
            EventBus.$emit(Events.OPEN_MODAL, ModalsList.SUBSCRIBE_MODAL, {
                user: this.user,
            })
        },

        openFollowers() {
            if (this.user.owner || this.showFollowers) {
                EventBus.$emit(Events.OPEN_MODAL, ModalsList.FOLLOWERS_MODAL, {
                    user: this.user,
                })
            }
        },

        openFollowings() {
            if (this.user.owner) {
                EventBus.$emit(Events.OPEN_MODAL, ModalsList.FOLLOWINGS_MODAL)
            }
        },
    },

    created() {
        this.load()
    },
}
</script>
